<script setup lang="ts">
import { svgIcon } from "@/common/components";
</script>

<template>
  <div class="full-loading">
    <div class="icon animate spin">
      <svg-icon icon="loading" size="3rem" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.full-loading {
  position: fixed;
  z-index: 999;
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--black-transparent);

  .icon {
    color: var(--primary);
  }
}
</style>